import Button from "components/common/Button";
import { useNav } from "components/common/Navbar/NavContext";
import PageTitleSection from "components/common/PageTitleSection";
import PurchaseOrder from "components/views/Ldb/Dashboard/Orders/PurchaseOrder";
import { useNavigationHandler } from "hooks/useNavigationHandler";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AccountPermissions } from "types/permissions";

const Purchase = () => {
    const navigate = useNavigate();
    const { goBack } = useNavigationHandler({ fallbackPath: "/dashboard/purchase" });

    const { setNavName, setOnClick, setShowNavIcon } = useNav();

    useEffect(() => {
        setNavName("Purchase");
        setOnClick(() => () => {
            goBack();
        });
        setShowNavIcon(true);
    }, [setNavName, setOnClick, setShowNavIcon]);

    return (
        <div className="py-4 md:border border-slate-100 rounded-[8px] bg-white">
            <div className="mb-8 px-4 max-lg:hidden block ">
                <PageTitleSection
                    leftComp={<h3 className="text-xl font-rocGroteskMedium">Purchase Orders</h3>}
                />
            </div>

            <div className="px-4">
                <PurchaseOrder />
            </div>
        </div>
    );
};

export default Purchase;
